import { Types } from 'mongoose';

import { STAGE_ACTION, STAGE_ROUTING_STATUS } from '@shared/constants';

import {
  IBaseEntity,
  IContactAddress,
  IContactEmail,
  IContactNumber,
  IName,
} from '../common';
import { IFormBuilderField } from '../workflows';

// export interface IRequestDocument extends IBaseEntity {
//   workflowId: string;
//   workflowCreatedBy: string;
//   basicInformation?: IRequestDocumentBasicInfo;
//   documentInformation?: IRequestDocumentDocumentInfo[];
//   customerInformation?: IRequestDocumentCustomerInfo;
//   status: string;
//   link_expired?: boolean;
// }

export interface IFormControlValue {
  formControlName?: string;
  value:
    | string
    | IContactNumber[]
    | IContactEmail[]
    | IName
    | Date
    | string[]
    | IContactAddress[]
    | IRequestDocumentDocumentInfo[]; // can be string | number | boolean | string[] depending on the field type
}

export interface INodeFormValue {
  value: IFormControlValue;

  //aggregate
  config?: IFormBuilderField;
}

export interface INodeFormSavePayload extends IBaseEntity {
  virtual_module_id?: string;
  id: string;
  workflow_id: string | Types.ObjectId;
  value?: INodeFormValue[];
  status?: string;
  last_trigger_action?: STAGE_ACTION;
}
export interface IThankingPopupInputs {
  title: string;
  sub_title: string;
}

export interface DocumentResponse {
  documentName: string;
  identity_id: string;
  files: UploadDocuments[];
}
export interface IRequestDocumentResponseData extends IBaseEntity {
  documents: DocumentResponse[];
}
export interface IRequestDocumentBasicInfo {
  name: string;
  description: string;
  due_date: Date;
}
export interface UploadDocuments {
  type: string;
  status: string;
  file_id: string;
  name: string;
  uploaded_date: string;
}

export interface IRequestDocumentDocumentInfo {
  title?: string;
  subTitle?: string;
  name: string;
  formControlName?: string;
  description: string;
  maximum_file_size: number;
  allowed_file_types: string[];
  isRequired: boolean;
  isMultipleUpload: boolean;
  status?: DOCUMENT_STATUS;
  identity_id?: string;
  files?: UploadDocuments[];
}

export interface IRequestDocumentCustomerInfo {
  name: IName;
  email: IContactEmail;
  contact_number: IContactNumber;
  security_option: string;
  source: string;
  identification_number?: string;
}

export enum DOCUMENT_TYPE {
  MANDATORY = 'Mandatory',
  OPTIONAL = 'Optional',
}

export enum DOCUMENT_STATUS {
  UPLOADED = 'UPLOADED',
  NOT_UPLOADED = 'NOT UPLOADED',
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
}
export enum MULTIPLE_CAPABILITY {
  ALLOW_MULTIPLE = 'Allow',
  NOT_ALLOW_MULTIPLE = 'Not Allow',
}

export enum DOCUMENT_STAGE {
  QUOTATION = 'Quotations',
  PROPOSAL = 'Proposal',
}

export enum FILE_FORMATS {
  PDF = 'PDF',
  DOC = 'DOCX',
  SVG = 'SVG',
  PNG = 'PNG',
  JPG = 'JPE|JPG',
  CSV = 'CSV',
  XLS = 'XLS',
  EML = 'EML',
}
